<template>
  <div class="form">
    <div class="form__content">
      <h1 class="extra-large-headline">
        {{ $t('PaymentCooling.title.coolingPeriod') }}
      </h1>
      <p class="bodycopy">
        {{ $t('PaymentCooling.bodyCopy.paragraph1') }}
      </p>

      <p
        class="bodycopy"
        v-html="
          $t('PaymentCooling.bodyCopy.paragraph2', {
            riskSummaryLink: `
            <a href='https://banxa.com/due-diligence/'
               target='_blank'
               rel='noopener'
            >
              ${$t('PaymentCooling.link.riskSummary')}
            </a>`,
          })
        "
      />

      <p class="end-message">
        {{ $t('PaymentCooling.bodyCopy.endMessage') }}
      </p>

      <ButtonBase @onButtonClick="handleButtonEvent">
        {{ $t('ButtonBase.label.iUnderstand') }}
      </ButtonBase>
    </div>
  </div>
</template>
<script setup>
import { useTitle } from '@vueuse/core';
import { useGlobalStore } from '@/stores/globalStore';

import ButtonBase from '@/components/ui/buttons/ButtonBase.vue';

const globalStore = useGlobalStore();
const handleButtonEvent = async () => {
  const { returnUrl } = globalStore.getMerchantSettings;
  window.top.location.href = returnUrl;
};
useTitle('Banxa - Your cooling off period has begun');
</script>

<style scoped lang="scss">
.form__content {
  .extra-large-headline {
    max-width: 350px;
  }
  .bodycopy {
    margin-bottom: 1rem;
  }

  .end-message {
    font-weight: 900;
    font-size: $font-head;
    margin-bottom: 2rem;
  }
}
</style>
